<template lang="pug">
  .form
    b-form-group(
      content-cols-sm
      :label="$t('request-agent')"
      label-for="device-name"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-form-input#device-name(v-model="form.device_alias" style="width: 244px" disabled)
    b-form-group(
      content-cols-sm
      :label="$t('ID')"
      label-for="id"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-form-input#id(v-model="form.requester_id" style="width: 244px" disabled)
    b-form-group(
      content-cols-sm
      :label="$t('applicant')"
      label-for="name"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-form-input#name(v-model="form.requester_name" style="width: 244px" disabled)
    b-form-group.request-date(
      content-cols-sm
      :label="$t('start_datetime')"
      label-for="app-period-start"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-input-group.time-group
        b-form-datepicker#app-period-start.mt-0.c-w-5(
          v-model="form.start_time",
          :placeholder="$t('start_time_ch')"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :disabled="true"
        )
        b-input-group-append.d-flex.align-items-center
          b-select.ml-2.h-100(v-model="form.start_time_hour" :options="hourOptions" size="sm" :disabled="true")
          span.ml-1 {{$t('hour')}}
          b-select.ml-2.h-100(v-model="form.start_time_min" :options="minOptions" size="sm" :disabled="true")
          span.ml-1 {{$t('minute')}}
    b-form-group.request-date.d-flex.align-items-center(
      content-cols-sm
      :label="$t('end_datetime')"
      label-for="app-period-end"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-input-group.time-group
        b-form-datepicker#app-period-end.mt-0.c-w-5(
          v-model="form.end_time"
          :placeholder="$t('end_time_ch')"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :disabled="true"
        )
        b-input-group-append.d-flex.align-items-center
          b-select.ml-2.h-100(v-model="form.end_time_hour" :options="hourOptions" size="sm" :disabled="true")
          span.ml-1 {{$t('hour')}}
          b-select.ml-2.h-100(v-model="form.end_time_min" :options="minOptions" size="sm" :disabled="true")
          span.ml-1 {{$t('minute')}}
    b-form-group.request-date.d-flex.align-items-center(
      content-cols-sm
      :label="$t('approval_type')"
      label-for="approver-type"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-radio-group#approver-type(
        v-model="form.post_approval"
        :options="[{text: this.$t('pre_approval'), value: 0}, {text: this.$t('post_approval'), value: 1}, {text: this.$t('exception'), value: 2}]"
        :disabled="true"
      )
    b-form-group(
      content-cols-sm
      :label="$t('approval_line')"
      label-for="approval"
      label-cols-sm="2"
      label-align-sm="left"
    )
      .d-flex.align-items-center
        b-form-input#approval.non-flex(
          v-model="form.approver"
          :disabled="true"
          style="width: 200px"
        )
    b-form-group(
      content-cols-sm
      :label="$t('application_reason')"
      label-for="approval-kind"
      label-cols-sm="2"
      label-align-sm="left"
    ).align-items-start
      b-form-textarea#approval-reason(v-model="form.reason" :disabled="true")

    b-form-group.request-date.d-flex.align-items-center(
      content-cols-sm
      :label="$t('application_datetime')"
      label-for="app-period-end"
      label-cols-sm="2"
      label-align-sm="left"
    )
      b-input-group.time-group
        b-form-datepicker#app-period-end.mt-0.c-w-5(
          v-model="form.create_time"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          :disabled="true"
        )
        b-input-group-append.d-flex.align-items-center
          b-select.ml-2.h-100(v-model="form.create_time_hour" :options="hourOptions" size="sm" :disabled="true")
          span.ml-1 {{$t('hour')}}
          b-select.ml-2.h-100(v-model="form.create_time_min" :options="minOptions" size="sm" :disabled="true")
          span.ml-1 {{$t('minute')}}

    b-form-group(
      v-if="form.kind"
      content-cols-sm
      :label="$t('management_page.approval_opinion')"
      label-for="approval-kind"
      label-cols-sm="2"
      label-align-sm="left"
    ).align-items-center
      b-select#approval-kind.mb-2(
        size="sm"
        v-model="form.kind",
        :options="kindOptions",
        :placeholder="$t('approval_reason')"
        style="width: 200px"
        :disabled="true"
      )
      b-form-textarea#approval-reason(v-if="form.kind === 0" v-model="form.reason" :disabled="true")
</template>

<script>
import _ from "lodash"

export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hourOptions() {
      return _.range(0, 24).map(item => {
        const num = item < 10 ? "0" + item : item
        return { text: num, value: num }
      })
    },
    minOptions() {
      return _.range(0, 60).map(item => {
        const num = item < 10 ? "0" + item : item
        return { text: num, value: num }
      })
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped></style>
